/* screens/workspace/feed/ToolCallProgress.jsx — прогресс вызовов инструментов (S6).
   Показывается под стримящимся пузырём ассистента: строки running/done/error
   (иконка статуса + summary). При завершении строки done тускнеют. Не рендерится без вызовов.
   Источник: 07 §2.14. ХЕНДОФФ → frontend/components/chat/ToolCallProgress.jsx (замена). */

import { Icon } from '../../../components/ui/Icon.jsx';

  function ToolCallProgress({ calls, streaming }) {
    const list = calls || [];
    if (!list.length && !streaming) return null;
    const allDone = list.length && list.every((c) => c.status !== 'running');
    return (
      <div className="tool-progress" role="status" aria-live="polite">
        {list.map((c, i) => {
          const ic = c.status === 'done' ? 'check' : c.status === 'error' ? 'x-circle' : 'spinner';
          return (
            <div key={i} className={'tool-progress__row tool-progress__row--' + c.status}>
              <Icon name={ic} size={14} />
              <span className="tool-progress__sum">{c.summary || c.name}</span>
            </div>
          );
        })}
        {streaming && !allDone && (
          <div className="tool-progress__row tool-progress__row--running">
            <Icon name="spinner" size={14} /><span className="tool-progress__sum">Обрабатываю…</span>
          </div>
        )}
      </div>
    );
  }

export { ToolCallProgress };
